import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import Button, { PRIMARY } from '@/common/components/Button/Button';
import { SIZE_MEDIUM } from '@/common/components/Label/Label';
import styles from './DriveItemDetailsFooter.module.less';
function DriveItemDetailsFooter() {
    return (_jsx("div", { className: styles.driveItemDetailsFooter, children: _jsxs("div", { className: styles.rightGroup, children: [_jsx(Button, { "aria-label": "drive-item-cancel", form: "drive-modal-form", type: "reset", className: styles.button, children: "Cancel" }), _jsx(Button, { className: styles.button, "aria-label": "drive-item-save", form: "drive-modal-form", type: "submit", color: PRIMARY, size: SIZE_MEDIUM, children: "Save" })] }) }));
}
export default observer(DriveItemDetailsFooter);
